// extracted by mini-css-extract-plugin
module.exports = {"landingContentSection":"LandingContentSection_landingContentSection__m_DDN","phoneVideo":"LandingContentSection_phoneVideo__XOmx_","image":"LandingContentSection_image__xyFur"};